import { useMutation } from 'react-query';
import axiosClient from '@lib/utils/axiosClient';

interface Data {
  address: string;
}

const validateDirectEmail = async (payload: Data) => {
  const response = await axiosClient.post('v2/directAddresses/validate', payload);
  return response.data as Response;
};

const useDirectAddressValidate = () => {
  const userMutation = useMutation(validateDirectEmail);
  return userMutation;
};

export default useDirectAddressValidate;
